export const actionTypes = {
  GET_TEMPLATE_T: "GET_TEMPLATE_T",
  GET_TEMPLATE_T_SUCCESS: "GET_TEMPLATE_T_SUCCESS",
  GET_TEMPLATE_T_FAILURE: "GET_TEMPLATE_T_FAILURE",
  POST_TEMPLATE_T: "POST_TEMPLATE_T",
  POST_TEMPLATE_T_SUCCESS: "POST_TEMPLATE_T_SUCCESS",
  POST_TEMPLATE_T_FAILURE: "POST_TEMPLATE_T_FAILURE",
  DELETE_TEMPLATE_T: "DELETE_TEMPLATE_T",
  DELETE_TEMPLATE_T_SUCCESS: "DELETE_TEMPLATE_T_SUCCESS",
  DELETE_TEMPLATE_T_FAILURE: "DELETE_TEMPLATE_T_FAILURE",

  GET_FIELDS_TYPE: "GET_FIELDS_TYPE",
  GET_FIELDS_TYPE_SUCCESS: "GET_FIELDS_TYPE_SUCCESS",
  GET_FIELDS_TYPE_FAILURE: "GET_FIELDS_TYPE_FAILURE",

  GET_TEMPLATE_FIELDS: "GET_TEMPLATE_FIELDS",
  GET_TEMPLATE_FIELDS_SUCCESS: "GET_TEMPLATE_FIELDS_SUCCESS",
  GET_TEMPLATE_FIELDS_FAILURE: "GET_TEMPLATE_FIELDS_FAILURE",
  POST_TEMPLATE_FIELDS: "POST_TEMPLATE_FIELDS",
  POST_TEMPLATE_FIELDS_SUCCESS: "POST_TEMPLATE_FIELDS_SUCCESS",
  POST_TEMPLATE_FIELDS_FAILURE: "POST_TEMPLATE_FIELDS_FAILURE",
  DELETE_TEMPLATE_FIELDS: "DELETE_TEMPLATE_FIELDS",
  DELETE_TEMPLATE_FIELDS_SUCCESS: "DELETE_TEMPLATE_FIELDS_SUCCESS",
  DELETE_TEMPLATE_FIELDS_FAILURE: "DELETE_TEMPLATE_FIELDS_FAILURE",

  GET_SERV: "GET_SERV",
  GET_SERV_SUCCESS: "GET_SERV_SUCCESS",
  GET_SERV_FAILURE: "GET_SERV_FAILURE",
  POST_SERV: "POST_SERV",
  POST_SERV_SUCCESS: "POST_SERV_SUCCESS",
  POST_SERV_FAILURE: "POST_SERV_FAILURE",
  DELETE_SERV: "DELETE_SERV",
  DELETE_SERV_SUCCESS: "DELETE_SERV_SUCCESS",
  DELETE_SERV_FAILURE: "DELETE_SERV_FAILURE",

  GET_SERV_FIELDS: "GET_SERV_FIELDS",
  GET_SERV_FIELDS_SUCCESS: "GET_SERV_FIELDS_SUCCESS",
  GET_SERV_FIELDS_FAILURE: "GET_SERV_FIELDS_FAILURE",
  POST_SERV_FIELDS: "POST_SERV_FIELDS",
  POST_SERV_FIELDS_SUCCESS: "POST_SERV_FIELDS_SUCCESS",
  POST_SERV_FIELDS_FAILURE: "POST_SERV_FIELDS_FAILURE",
  DELETE_SERV_FIELDS: "DELETE_SERV_FIELDS",
  DELETE_SERV_FIELDS_SUCCESS: "DELETE_SERV_FIELDS_SUCCESS",
  DELETE_SERV_FIELDS_FAILURE: "DELETE_SERV_FIELDS_FAILURE",

  GET_EXTERNAL_FIELDS: "GET_EXTERNAL_FIELDS",
  GET_EXTERNAL_FIELDS_SUCCESS: "GET_EXTERNAL_FIELDS_SUCCESS",
  GET_EXTERNAL_FIELDS_FAILURE: "GET_EXTERNAL_FIELDS_FAILURE",
  POST_EXT_FIELDS: "POST_EXT_FIELDS",
  POST_EXT_FIELDS_SUCCESS: "POST_EXT_FIELDS_SUCCESS",
  POST_EXT_FIELDS_FAILURE: "POST_EXT_FIELDS_FAILURE",
  DELETE_EXT_FIELDS: "DELETE_EXT_FIELDS",
  DELETE_EXT_FIELDS_SUCCESS: "DELETE_EXT_FIELDS_SUCCESS",
  DELETE_EXT_FIELDS_FAILURE: "DELETE_EXT_FIELDS_FAILURE",

  RESET_SERVICE_REQ_ADMIN_STATE: "RESET_SERVICE_REQ_ADMIN_STATE",
};

export const getFieldsType = () => ({
  type: actionTypes.GET_FIELDS_TYPE,
});

export const getFieldsTypeSuccess = (response: any) => ({
  type: actionTypes.GET_FIELDS_TYPE_SUCCESS,
  payload: response,
});

export const getFieldsTypeFailure = (err: Error) => ({
  type: actionTypes.GET_FIELDS_TYPE_FAILURE,
  err,
});

export const getTemplateTicketAction = () => ({
  type: actionTypes.GET_TEMPLATE_T,
});

export const getTemplateTicketSuccess = (response: any) => ({
  type: actionTypes.GET_TEMPLATE_T_SUCCESS,
  payload: response,
});

export const getTemplateTicketFailure = (err: Error) => ({
  type: actionTypes.GET_TEMPLATE_T_FAILURE,
  err,
});

export const postTemplateTicketAction = (data: any) => ({
  type: actionTypes.POST_TEMPLATE_T,
  payload: data,
});

export const postTemplateTicketSuccess = (data: any) => ({
  type: actionTypes.POST_TEMPLATE_T_SUCCESS,
  payload: data,
});

export const postTemplateTicketFailure = (err: Error) => ({
  type: actionTypes.POST_TEMPLATE_T_FAILURE,
  err,
});

export const deleteTemplateTicketAction = (ids: any) => ({
  type: actionTypes.DELETE_TEMPLATE_T,
  payload: ids,
});

export const deleteTemplateTicketSuccess = (response: any) => ({
  type: actionTypes.DELETE_TEMPLATE_T_SUCCESS,
  payload: response,
});

export const deleteTemplateTicketFailure = (err: Error) => ({
  type: actionTypes.DELETE_TEMPLATE_T_FAILURE,
  err,
});

export const getTemplateTicketFieldsAction = () => ({
  type: actionTypes.GET_TEMPLATE_FIELDS,
});

export const getTemplateTicketFieldsSuccess = (response: any) => ({
  type: actionTypes.GET_TEMPLATE_FIELDS_SUCCESS,
  payload: response,
});

export const getTemplateTicketFieldsFailure = (err: Error) => ({
  type: actionTypes.GET_TEMPLATE_FIELDS_FAILURE,
  err,
});

export const postTemplateTicketFieldsAction = (data: any) => ({
  type: actionTypes.POST_TEMPLATE_FIELDS,
  payload: data,
});

export const postTemplateTicketFieldsSuccess = (response: any) => ({
  type: actionTypes.POST_TEMPLATE_FIELDS_SUCCESS,
  payload: response,
});

export const postTemplateTicketFieldsFailure = (err: Error) => ({
  type: actionTypes.POST_TEMPLATE_FIELDS_FAILURE,
  err,
});

export const deleteTemplateTicketFieldsAction = (ids: any) => ({
  type: actionTypes.DELETE_TEMPLATE_FIELDS,
  payload: ids,
});

export const deleteTemplateTicketFieldsSuccess = (response: any) => ({
  type: actionTypes.DELETE_TEMPLATE_FIELDS_SUCCESS,
  payload: response,
});

export const deleteTemplateTicketFieldsFailure = (err: Error) => ({
  type: actionTypes.DELETE_TEMPLATE_FIELDS_FAILURE,
  err,
});

export const getServiceReqAction = () => ({
  type: actionTypes.GET_SERV,
});

export const getServiceReqSuccess = (response: any) => ({
  type: actionTypes.GET_SERV_SUCCESS,
  payload: response,
});

export const getServiceReqFailure = (err: Error) => ({
  type: actionTypes.GET_SERV_FAILURE,
  err,
});

export const postServiceReqAction = (data: any) => ({
  type: actionTypes.POST_SERV,
  payload: data,
});

export const postServiceReqSuccess = (response: any) => ({
  type: actionTypes.POST_SERV_SUCCESS,
  payload: response,
});

export const postServiceReqFailure = (err: Error) => ({
  type: actionTypes.POST_SERV_FAILURE,
  err,
});

export const deleteServiceReqAction = (data: any) => ({
  type: actionTypes.DELETE_SERV,
  payload: data,
});

export const deleteServiceReqSuccess = (response: any) => ({
  type: actionTypes.DELETE_SERV_SUCCESS,
  payload: response,
});

export const deleteServiceReqFailure = (err: Error) => ({
  type: actionTypes.DELETE_SERV_FAILURE,
  err,
});

export const getServiceReqFieldsAction = () => ({
  type: actionTypes.GET_SERV_FIELDS,
});

export const getServiceReqFieldsSuccess = (response: any) => ({
  type: actionTypes.GET_SERV_FIELDS_SUCCESS,
  payload: response,
});

export const getServiceReqFieldsFailure = (err: Error) => ({
  type: actionTypes.GET_SERV_FIELDS_FAILURE,
  err,
});

export const postServiceReqFieldsAction = (data: any) => ({
  type: actionTypes.POST_SERV_FIELDS,
  payload: data,
});

export const postServiceReqFieldsSuccess = (response: any) => ({
  type: actionTypes.POST_SERV_FIELDS_SUCCESS,
  payload: response,
});

export const postServiceReqFieldsFailure = (err: Error) => ({
  type: actionTypes.POST_SERV_FIELDS_FAILURE,
  err,
});

export const deleteServiceReqFieldsAction = (ids: any) => ({
  type: actionTypes.DELETE_SERV_FIELDS,
  payload: ids,
});

export const deleteServiceReqFieldsSuccess = (response: any) => ({
  type: actionTypes.DELETE_SERV_FIELDS_SUCCESS,
  payload: response,
});

export const deleteServiceReqFieldsFailure = (err: Error) => ({
  type: actionTypes.DELETE_SERV_FIELDS_FAILURE,
  err,
});

export const getExternalFieldsAction = () => ({
  type: actionTypes.GET_EXTERNAL_FIELDS,
});

export const getExternalFieldsSuccess = (response: any) => ({
  type: actionTypes.GET_EXTERNAL_FIELDS_SUCCESS,
  payload: response,
});

export const getExternalFieldsFailure = (err: Error) => ({
  type: actionTypes.GET_EXTERNAL_FIELDS_FAILURE,
  err,
});

export const postExtFieldsAction = (data: any) => ({
  type: actionTypes.POST_EXT_FIELDS,
  payload: data,
});

export const postExtFieldsSuccess = (response: any) => ({
  type: actionTypes.POST_EXT_FIELDS_SUCCESS,
  payload: response,
});

export const postExtFieldsFailure = (err: Error) => ({
  type: actionTypes.POST_EXT_FIELDS_FAILURE,
  err,
});

export const deleteExtFieldsAction = (ids: any) => ({
  type: actionTypes.DELETE_EXT_FIELDS,
  payload: ids,
});

export const deleteExtFieldsSuccess = (response: any) => ({
  type: actionTypes.DELETE_EXT_FIELDS_SUCCESS,
  payload: response,
});

export const deleteExtFieldsFailure = (err: Error) => ({
  type: actionTypes.DELETE_EXT_FIELDS_FAILURE,
  err,
});

export const resetStateAction = () => ({
  type: actionTypes.RESET_SERVICE_REQ_ADMIN_STATE,
});
